import { HolderOutlined } from "@ant-design/icons";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Button } from "antd";
import classNames from "classnames";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { PropsWithChildren } from "react";

interface SortableFormFieldRowProps extends PropsWithChildren {
    id: string;
}

export const SortableFormFieldRow = ({ id, children }: SortableFormFieldRowProps) => {
    const { t } = usePaldockTranslation("forms.general-fields");
    const { attributes, listeners, setNodeRef, setActivatorNodeRef, transform, transition, isDragging } = useSortable({
        id,
    });

    const style: React.CSSProperties = {
        transform: CSS.Transform.toString(transform),
        transition,
        zIndex: isDragging ? 1 : undefined,
    };

    return (
        <div
            ref={setNodeRef}
            style={style}
            className={classNames(
                "group relative rounded-lg border border-transparent bg-[#00000005] px-4 py-4 transition-colors",
                isDragging && "border-[#96CACA] bg-[#2FA3A31A] shadow-md"
            )}
            data-dragging={isDragging || undefined}
        >
            <Button
                ref={setActivatorNodeRef}
                type="text"
                size="small"
                icon={<HolderOutlined />}
                aria-label={t("reorder")}
                className={classNames(
                    "absolute left-2 top-1/2 z-10 -translate-y-1/2 cursor-grab opacity-0 transition-opacity",
                    "group-hover:opacity-100 focus:opacity-100 active:cursor-grabbing",
                    isDragging && "opacity-100"
                )}
                {...attributes}
                {...listeners}
            />
            <div className="pl-6">{children}</div>
            {isDragging && <div className="absolute -bottom-1 left-0 h-[3px] w-full rounded bg-primary" />}
        </div>
    );
};
